export default "__VITE_ASSET__DDV5bEd0__"